import { ClientStatus } from '@/features/dashboard/clients/types/ClientStatus.ts';

export const CLIENT_STATUS_LABELS: Record<ClientStatus, string> = {
  [ClientStatus.ACTIVE]: 'Aktywny',
  [ClientStatus.CANCELLED]: 'Anulowany',
};

export const getClientStatusLabel = (status: ClientStatus): string =>
  CLIENT_STATUS_LABELS[status];
